import { Injectable } from "@angular/core";
import { RootStore } from "../../stores/root-store";
import { LoginProvider } from "../login/login";

/*
  Generated class for the DomainStorageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DomainStorageProvider {

    constructor(
        public rootStore: RootStore,
        public loginProvider: LoginProvider
    ) {
        this.rootStore = this.rootStore;
    }

    async doLogin(login, password) {
        let resultLogin = await this.loginProvider.doLogin(login, password);
        return resultLogin;
    }

    async getConfigData(autoSelectGroup = true) {
        return await this.rootStore.loadConfig(autoSelectGroup);
    }

    startupLoadData() {
        this.loginProvider.setConfigLoaded(true);
        return this.rootStore.startupLoadData();
    }
}
